import { useCallback } from 'react';
import { posthog } from '@/lib/posthog';

export const usePostHog = () => {
  const trackEvent = useCallback((eventName: string, properties?: Record<string, any>) => {
    if (posthog.__loaded) {
      posthog.capture(eventName, properties);
    }
  }, []);

  const identifyUser = useCallback((userId: string, properties?: Record<string, any>) => {
    if (posthog.__loaded) {
      posthog.identify(userId, properties);
    }
  }, []);

  const resetUser = useCallback(() => {
    if (posthog.__loaded) {
      posthog.reset();
    }
  }, []);

  return {
    trackEvent,
    identifyUser,
    resetUser,
  };
};
